import { useCallback, useEffect, useRef, useState } from 'react';

/** Seconds left on a one-second countdown, and a way to (re)start it. */
export function useCountdown(): [number, (seconds: number) => void] {
  const [left, setLeft] = useState(0);
  const timer = useRef<ReturnType<typeof setInterval> | undefined>(undefined);

  const start = useCallback((seconds: number) => {
    clearInterval(timer.current);
    setLeft(seconds);
    timer.current = setInterval(() => {
      setLeft((current) => {
        if (current <= 1) {
          clearInterval(timer.current);
          return 0;
        }
        return current - 1;
      });
    }, 1000);
  }, []);

  useEffect(() => () => clearInterval(timer.current), []);
  return [left, start];
}
